import './AdminHomePage.css';
import { useLanguage } from '../utils/LanguageContext';
import translations from './AdminHomePage.lang.json';
import AdminBackgroundImage from '../images/adminBackgroundImage.jpg';
import DollarSignSymbol from '../images/dollarsignSymbol.svg';
import PeopleIcon from '../images/peopleIcon.svg';
import marketingTranslations from '../components/MarketingLeadForm.lang.json';
import { NavigateButton } from '../components/common/CommonComponents';
import { useClientParams } from '../utils/AppConfigContext';

const AdminHomePage = () => {
  const params = useClientParams();
  const { lang } = useLanguage(translations, marketingTranslations);

  return (
    <main className="admin-homepage-container">
      <div className="admin-homepage-top-section">
        <div className="admin-background-image-container">
          <img src={AdminBackgroundImage} alt="Background" className="admin-background-image" />
          <h2 className="page-title">{lang('adminHomePageTitle')}</h2>
          <div className="admin-overlay-content">
            <h3>{lang('adminSignupButton')}</h3>
            {params.MARKETING_MODE ? (
              <NavigateButton to="/register" type="primary">
                {lang('registerButton')}
              </NavigateButton>
            ) : (
              <NavigateButton type="primary" to="/admin/signup">
                {lang('createAdminAccount')}
              </NavigateButton>
            )}
          </div>
        </div>
        <div className="content-container">
          <div className="admin-text-content">
            <div className="admin-section1">
              <div className="admin-section1-bullet-text">
                <img src={PeopleIcon} alt="PeopleBullet" className="people-icon" />
                <h3 className="admin-section1-text">{lang(`adminHomePageSection1Bullet1`)}</h3>
              </div>
              <div className="admin-section1-bullet-text">
                <img src={PeopleIcon} alt="Bullet" className="people-icon" />
                <h3 className="admin-section1-text">{lang(`adminHomePageSection1Bullet2`)}</h3>
              </div>
            </div>
            <div className="question-answer">
              <div className="qa-question">
                <img src={DollarSignSymbol} alt="Bullet" className="bullet-icon" />
                <span className="question-text">{lang('adminHomePageParagraph2Question')}</span>
              </div>
              <div className="qa-answer">
                <span>{lang('adminHomePageParagraph2')}</span>
              </div>
            </div>
            <div className="question-answer">
              <div className="qa-question">
                <img src={DollarSignSymbol} alt="Bullet" className="bullet-icon" />
                <span className="question-text">{lang('adminHomePageParagraph3Question')}</span>
              </div>
              <div className="qa-answer">
                <span>{lang('adminHomePageParagraph3')}</span>
              </div>
            </div>
            <div className="question-answer">
              <div className="qa-question">
                <img src={DollarSignSymbol} alt="Bullet" className="bullet-icon" />
                <span className="question-text">{lang('adminHomePageParagraph4Question')}</span>
              </div>
              <div className="qa-answer">
                <span>{lang('adminHomePageParagraph4')}</span>
              </div>
            </div>
            {/* <p>{lang(`adminReferralProgramCopy`)}</p> */}
            {/* TODO: Add link to referral program ToS */}
            <div className="admin-call-to-action">
              {params.MARKETING_MODE ? (
                <NavigateButton to="/register" type="primary">
                  {lang('registerButton')}
                </NavigateButton>
              ) : (
                <NavigateButton type="primary" to="/admin/signup">
                  {lang('createAdminAccount')}
                </NavigateButton>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="homepage-card">
        <div className="homepage-card-text">
          <h3>{lang('homepageRouteButtonExplanation')}</h3>
          <NavigateButton to="/" type="primary" className="homepage-button">
            {lang('homepageRouteButton')}
          </NavigateButton>
        </div>
      </div>
    </main>
  );
};

export default AdminHomePage;
